/* globals Store */
import axios from 'axios'
import qs from 'qs'
import cfg from '@/vue-caas/config/config.js'
import http from "http"
import https from "https"

const httpAgent = new http.Agent({ keepAlive: true })
const httpsAgent = new https.Agent({ keepAlive: true })

import {
  handleResponseError,
  closeAlert,
  hideProgress,
} from "@/vue-dlb/utils/sys-util.js";

const BASE_URL = `${cfg.setupApiUrl}/`;

const ajax = axios.create({
  baseURL: BASE_URL,
  httpAgent,
  httpsAgent,
  // timeout: 30000
  timeout: false
  // params: {} // do not remove this, its added to add params later in the config
})

ajax.interceptors.response.use(
  function (response) {
    hideProgress();
    closeAlert(1000);
    console.log('--------- RESPONSE -------------');
    // console.log(response.data);
    return response;
  },
  function (error) {
    console.log('-------- RESPONSE ERROR --------');
    console.log(error);
    hideProgress();
    handleResponseError(error);
    return Promise.reject(error);
  }
)

export default {
  postData(action, data) {
    let url = `${BASE_URL}`
    url += action
    return ajax({
      method: 'post',
      url: url,
      data: qs.stringify(data),
      //timeout: 30000,
      timeout: false,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
        'hash': data.hash
      }
    })
  }

}
